module.exports = __webpack_public_path__ + "static/media/logo_yuwen.9b804ebf.png";